import React from 'react'
import { ServerConfig } from 'config'

import NonPaginatedList from '../../components/EntryListAndEdit/NonPaginatedList'


const TenantPrinters = () => {
  const non_editable_fields = [];

  const editable_fields = [
    ["id", "id", ""],
    ["tenant_id", "Tenant ID", "tenant"],
    ["name", "Name"],
  ];

  return (
    <>
      <NonPaginatedList
        list_get_url={`${ServerConfig.SERVER_URL}/admin/printers`}
        detail_get_url={`${ServerConfig.SERVER_URL}/admin/printers/`}
        detail_put_url={`${ServerConfig.SERVER_URL}/admin/printers/`}
        add_new_url = {`${ServerConfig.SERVER_URL}/admin/printers/`}

        column_names={["id", "name", "edit"]}
        header_names={["id", "name", ""]}

        optional_column_names={["tenant_id"]}
        optional_header_names={["Tenant ID"]}

        editable_fields={editable_fields}
        non_editable_fields={non_editable_fields}
        //ledger_get_url = '/ledger/customer/'
        //show_machine_stats={true}
      />
    </>
  )
}

export default TenantPrinters
